import { render } from "./SecuredImage.vue?vue&type=template&id=85063a50&ts=true"
import script from "./SecuredImage.vue?vue&type=script&lang=ts"
export * from "./SecuredImage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__